/*====================================
    企業用戶 相關功能Factory

    Author : Gray
    最後更新時間 : 2017 / 05 / 18
====================================*/

window.InifECShared.factory("BusinessMemberService", ['$q', '$http', function($q, $http) {

    var factory = this;

    var businessUser = {
        businessmrscid: undefined, // 企業用戶id
        mrscid: undefined, // 使用者id
        email: "", // 使用者電子郵件
        mobilephone: "", // 使用者手機
        userpointtype: undefined, // 用戶型態 0: 預儲 1: 月結
        monthlylimit: undefined, // 月結額度上限
        name: "", // 姓名
        company: "", // 公司
        invoice: "", // 統一編號
        fax: "", // 傳真號碼
        phone: "", // 聯絡電話
        phoneExtension: "", // 分機號碼
        address: "", // 聯絡地址
        postal: "", // 郵遞區號
        isNoPassword: false, // 企業用戶一定有密碼
        agent: "", // 業務代理人
    };

    // --------------------------------
    // 重設企業用戶資訊
    // --------------------------------
    var logutResetInfo = function() {

        factory.businessUser.businessmrscid = undefined;
        factory.businessUser.mrscid = undefined;
        factory.businessUser.email = "";
        factory.businessUser.mobilephone = "";
        factory.businessUser.userpointtype = undefined;
        factory.businessUser.monthlylimit = undefined;
        factory.businessUser.name = "";
        factory.businessUser.company = "";
        factory.businessUser.invoice = "";
        factory.businessUser.fax = "";
        factory.businessUser.phone = "";
        factory.businessUser.phoneExtension = "";
        factory.businessUser.address = "";
        factory.businessUser.postal = "";
        factory.businessUser.agent = "";
    }

    // --------------------------------
    // 取得企業用戶資訊
    // --------------------------------
    var getSelfProfile = function(skipCache) {

        if(factory.userdefer && !skipCache){
            return factory.userdefer.promise;
        }

        factory.userdefer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "GET",
            params: {
                op: "getSelfProfile"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                factory.userdefer.reject(data.error);
            } else {
                data.phone = removeDashInNumber(data.phone);
                data.mobilephone = removeDashInNumber(data.mobilephone);

                factory.businessUser.businessmrscid = data.businessmrscid;
                factory.businessUser.mrscid = data.mrscid;
                factory.businessUser.email = data.email;
                factory.businessUser.mobilephone = data.mobilephone;
                factory.businessUser.userpointtype = data.userpointtype;
                factory.businessUser.monthlylimit = data.monthlylimit;
                factory.businessUser.name = data.name || '';
                factory.businessUser.company = data.company || '';
                factory.businessUser.invoice = data.invoice || '';
                factory.businessUser.fax = data.fax || '';
                factory.businessUser.phone = data.phone || '';
                factory.businessUser.phoneExtension = data.phoneExtension || '';
                factory.businessUser.address = data.address || '';
                factory.businessUser.postal = data.postal || '';
                factory.businessUser.agent = data.agent || '';                

                factory.userdefer.resolve(factory.businessUser);
            }
        }).error(function(data, status, headers, config) {
            factory.userdefer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.getSelfProfile request error.");
            console.error("status : " + status);
        });

        return factory.userdefer.promise;
    }

    // --------------------------------
    // 企業用戶登入 by id
    // --------------------------------
    var loginById = function(businessmrscid, passwd) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "loginById",
                businessmrscid: businessmrscid,
                passwd: passwd,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                getSelfProfile();

                defer.resolve(true);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.loginById request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 企業用戶登入 by email
    // --------------------------------
    var loginByEmail = function(email, passwd) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "loginByEmail",
                email: email,
                passwd: passwd,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                getSelfProfile();

                defer.resolve(true);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.loginByEmail request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 企業用戶登入 by mobilephone
    // --------------------------------
    var loginByMobilephone = function(mobilephone, passwd) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "loginByMobilephone",
                mobilephone: mobilephone,
                passwd: passwd,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                getSelfProfile();

                defer.resolve(true);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.loginByMobilephone request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 更新密碼
    // 1. 忘記密碼的話 要傳email或mobilephone token 和 新密碼
    // 2. 如果是單純更改密碼，只要傳新密碼 和token 而token是舊密碼
    // ------------------------------
    var updatePassword = function(token, passwd, email) {

        var defer = $q.defer();

        $http({
            url:  SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "updatePassword",
                confirmkey: token,
                passwd: passwd,
                email: email,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.updatePassword request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 忘記密碼
    // --------------------------------
    var forgotPassword = function(email) {

        var defer = $q.defer();

        $http({
            url:  SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "forgotPassword",
                email: email,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.forgotPassword request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 修改企業用戶資料
    // --------------------------------
    var updateInfo = function(businessUser) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "updateInfo",
                name: businessUser.name,
                company: businessUser.company,
                invoice: businessUser.invoice,
                phone: businessUser.phone,
                phoneExtension: businessUser.phoneExtension,
                address: businessUser.address,
                postal: businessUser.postal,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                factory.businessUser.name = businessUser.name;
                factory.businessUser.company = businessUser.company;
                factory.businessUser.invoice = businessUser.invoice;
                factory.businessUser.phone = businessUser.phone;
                factory.businessUser.phoneExtension = businessUser.phoneExtension;
                factory.businessUser.address = businessUser.address;
                factory.businessUser.postal = businessUser.postal;

                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.updateInfo request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 企業用戶申請
    // --------------------------------
    var applyBusinessMember = function(businessmrscid, passwd, email, mobilephone, name, company, invoice, phone, phoneExtension, address, postal) {

        var defer = $q.defer();

        phone = removeDashInNumber(phone);
        mobilephone = removeDashInNumber(mobilephone);
        
        $http({
            url:  SECURE_INIFEC_URL + "/BusinessMemberApplicationAction.do",
            method: "POST",
            data: $.param({
                op: "applyBusinessMember",
                businessmrscid: businessmrscid,
                passwd: passwd,
                email: email,
                mobilephone: mobilephone,
                name: name,
                company: company,
                invoice: invoice,
                phone: phone,
                phoneExtension: phoneExtension,
                address: address,
                postal: postal,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(true);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.applyBusinessMember request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 企業用戶註冊
    // --------------------------------
    var register = function(businessmrscid, passwd, email, mobilephone, name, company, invoice, phone, phoneExtension, address, postal) {

        var defer = $q.defer();

        phone = removeDashInNumber(phone);
        mobilephone = removeDashInNumber(mobilephone);
        
        $http({
            url:  SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            data: $.param({
                op: "register",
                businessmrscid: businessmrscid,
                passwd: passwd,
                email: email,
                mobilephone: mobilephone,
                name: name,
                company: company,
                invoice: invoice,
                phone: phone,
                phoneExtension: phoneExtension,
                address: address,
                postal: postal,
                createfrommobile: window.isMobile || window.location.protocol == "file:",
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(true);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.register request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 完成帳號認證
    // ------------------------------
    var finishApply = function(token) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            params: {
                op: "finishApply",
                token: token
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.finishApply request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 重發認證信
    // ------------------------------
    var resendInvitation = function(email) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/BusinessMemberAction.do",
            method: "POST",
            params: {
                op: "resendInvitation",
                email: email
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BusinessMemberService.resendInvitation request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.businessUser = businessUser; // 使用者資訊

    /*==========================
        Methods
    ==========================*/
    factory.logutResetInfo = logutResetInfo; // 重設企業用戶資訊
    factory.getSelfProfile = getSelfProfile; // 取得企業用戶資訊
    factory.loginById = loginById; // 企業用戶登入 by id
    factory.loginByEmail = loginByEmail; // 企業用戶登入 by email
    factory.loginByMobilephone = loginByMobilephone; // 企業用戶登入 by mobilephone
    factory.updatePassword = updatePassword; // 更新密碼
    factory.forgotPassword = forgotPassword; // 忘記密碼
    factory.updateInfo = updateInfo; // 修改企業用戶資料
    factory.applyBusinessMember = applyBusinessMember; // 企業用戶申請
    factory.register = register; // 企業用戶註冊
    factory.finishApply = finishApply; // 完成帳號認證
    factory.resendInvitation = resendInvitation; // 重發認證信

    return factory;
}]);
